module.exports = {"id":"222457","name":"Bernard Mensah","rating":"73","photo":"./data/images/photos/2/222457.png","club":{"name":"Kasimpaşa","logo":"./data/images/clubs/Kasimpasa.png"},"positions":["MOC","MG"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/BernardMensah0.json
// module id = 587
// module chunks = 0